<template>
  <title>{{ title }}</title>
  <link rel="stylesheet" href="/css/home.css">
  <link rel="stylesheet" href="/css/contact.css">
  <link rel="stylesheet" href="/css/client.css">
  <link rel="stylesheet" href="/css/about_us.css">
  <link href="https://cdn.jsdelivr.net/gh/repalash/gilroy-free-webfont@fonts/Gilroy-Mideum.css" rel="stylesheet">
 
  <div>
    
    <!-- <header>
      
      <h1 class="company-name">{{ companyName }}</h1>
      <h2 class="company-category">{{ companyCategory }}</h2>
     
    </header> -->
    <section class="home-section-container">
      <div class="video-container" >
        <video class="background-video" autoplay playsinline loop muted ref="video" >
          <source src="/videos/FinalShowReel.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
     

      <div class="logo-name-container">
        <!-- <nav class="top-nav"> -->
          <a href="/" ><img class="logo" src="/images/logo/logo_crp.png" ></a>
        <div class="navbar-container">
          <div class="nav-oprtfolio" style="border-right: 1px solid white;">
            <a href="#video-clips-section" @click.prevent="scrollToSection('our-portfolio-section')">Portfolio</a>
          </div>
          <div class="nav-ourclients" style="border-right: 1px solid white;">
            <a href="#our-clients-section" @click.prevent="scrollToSection('our-clients-section')">Clients</a>
          </div>
          <div class="nav-aboutus" style="border-right: 1px solid white;">
            <a href="#about-us-section" @click.prevent="scrollToSection('about-us-section')">About</a>
          </div>
          <div class="nav-contactus">
            <a href="#contact-us-section" @click.prevent="scrollToSection('contact-us-section')"> Contact</a>
          </div>
        </div>
        <!-- </nav> -->
        
        <div class="company-name-container">
          
            <div id="container">
                <span id="text1" ref="text1"></span>
                <span id="text2" ref="text2"></span>
            </div>

            <svg id="filters">
                <defs>
                    <filter id="threshold">
                        <feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0
                              0 1 0 0 0
                              0 0 1 0 0
                              0 0 0 255 -140" />
                    </filter>
                </defs>
            </svg>
            <div class="mobile-view-container">
              <div class="company-name">Zero</div>
              <div class="company-name">Latency</div>
              <div class="company-name">Productions</div>
              <div class="slogan">
                "Your Vision Our Creation."
              </div>
            </div>
            
        </div>
      </div>
    </section>
    <section class="video-clips-section" id="our-portfolio-section">
      <h3 class="section-title reveal">Our Portfolio</h3>
      <div class="video-clip reveal"
        v-for="(video, index) in videoSources"
        v-bind:key="index"
      >
      <a :href="video.video_code">
        <div class="video-title">{{ video.title }}</div>
        <video ref="portfolioVideo" class="clip-video" 
          muted 
          loop
          playsinline
          autoplay
          preload="none"
          @mouseover="handleMouseOver"
          @mouseout="handleMouseOut" >
          <source :src="video.path" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </a>
      </div>
      
    </section>
    
    <h3 class="client-section-title " id="our-clients-section">Our Trusted Clients</h3>
    <div class="marquee-client-container  ">
      <marquee scrollamount="12" onmouseover="this.stop();" onmouseout="this.start();">
        <div class="marquee-container">

          <div class="client-container " v-for="(client, index) in clients" v-bind:key="index">
              <img class="client-img" :src="client.client_logo" alt="Client Logo">
          </div>
        </div>
    </marquee>
    </div>


    <!-- About Us Section -->
    <section class="about-us" id="about-us-section">
      <div class="company-details">
        <!-- <img src="/images/members/backgroud_grp.png"/> -->

        <div class="about-us-title">
          <h3>About Us</h3>
        </div>
        <div class="cmp-desc-grp">
          <div class="company-description">
            <h4>Welcome To Zero Latency Productions</h4>
            <p>{{ description }}</p>
            <img class="img-discription-bottom" src="/images/members/grp_emojis.png"/>
            <!-- <button class="about-us-button">Learn More</button> -->
          </div>
          <!-- <div class="company-grp-image reveal">
            <img src="/images/members/gunish_emoji.png"/>
          </div> -->
        </div>
      </div>
      
      <div class="team-container">
        <div class="our-team-title ">
          <h3>Our Team</h3>
          <p>{{ motives }}</p>

        </div>
        <div class="team-members">
          <article class="member-card" v-for="(member, index) in teamMembers" v-bind:key="index">
            <img src="/images/icons/Click-me.png" class="member-card-click-me"/>

            <img :src="member.avatar" :alt="member.name" class="member-avatar"/>
            <img :src="member.avatar_real" :alt="member.name" class="member-avatar-real"/>
            <div class="member-data">
              <h2 class="member-name">{{ member.name }}</h2>
              <span class="member-role">{{ member.role }}</span>
              <p class="member-bio">{{ member.bio }}</p>
              <!-- <a href="#" class="member-button">Read more</a> -->
            </div>
          </article>
        </div>
      </div>
    </section>
    <section class="contact-us-section " id="contact-us-section">
      
      <div class="contact-us-container">

        <h3>Contact Us</h3>
        <div class="left-contact-us-image">
        <!-- <img src="/images/background/contact-us.jpeg"/> -->
      </div>
        <div class="contact-info">
          
          <!-- <p><strong >Phone:</strong> <a class="telephone" href="tel:+918424864465">+918424864465</a></p>
          <p><strong>Email:</strong> <a class="telephone" href="mailto:0latencyproductions@gmail.com?subject=Inquiry">0latencyproductions@gmail.com</a></p> -->
          <div class="social-icons">
            <a href="https://wa.me/+918424864465?text=Hello%20Zero Latency Production" target="_blank">
              <img src="/images/icons/whatsapp.png" alt="LinkedIn">
            </a>
            <a href="mailto:0latencyproductions@gmail.com?subject=Inquiry" target="_blank">
              <img src="/images/icons/email.png" alt="LinkedIn">
            </a>
            <!-- <a href="https://www.linkedin.com/company/company" target="_blank">
              <img src="/images/icons/linkedin.png" alt="LinkedIn">
            </a> -->
            <a href="https://www.instagram.com/0latency_productions?igsh=Z3owZ3NxYnI3cHc2" target="_blank">
              <img src="/images/icons/instagram.png" alt="Instagram">
            </a>
            <!-- <a href="https://www.youtube.com/company" target="_blank">
              <img src="/images/icons/youtube.png" alt="YouTube">
            </a> -->
          </div>
        </div>
        <form @submit.prevent="submitForm" ref="myForm" class="my-form">
          <div class="form-group">
            <!-- <label for="name">Name</label> -->
            <input type="text" name="name" id="name" placeholder="Enter your name" v-model="form.name" required>
          </div>
          <div class="form-group">
            <!-- <label for="email">Email</label> -->
            <input type="email" name="email" id="email" placeholder="Enter your email" v-model="form.email" required>
          </div>
          <div class="form-group">
            <!-- <label for="message">Message</label> -->
            <textarea id="message" name="message" placeholder="Enter your message" v-model="form.message" required></textarea>
          </div>
          <button type="submit">Send</button>
          <p v-if="ackMessage" style="text-align: center;">{{ ackMessage }}</p>
        </form>
      </div>
    </section>
    <footer>
      <div class="footer-container">
        <div class="footer-content">
          <p>&copy; 2024 Zero Latency Productions. All rights reserved.</p>
          <nav class="footer-nav">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
            <a href="/contact-us">Contact Us</a>
          </nav>
        </div>
      </div>
    </footer>

    <div class="developer-name"><span>Website developed by: Siddhesh Khadapkar</span></div>
  </div>
</template>

<script>
// import axios from 'axios';
import emailjs from '@emailjs/browser';
import $ from 'jquery';
export default {
  name: 'HomePage',
  props:{
    texts: {
      type: Array,
      default:()=> [
        "YOUR",
        "VISION",
        "OUR",
        "CREATION",
        "ZERO LATENCY PRODUCTIONS",
        ":)",
      ],
    },
    morphTime: {
      type: Number,
      default: 1,
    },
    cooldownTime: {
      type: Number,
      default: 0.25,
    },
  },
  data() {
    return {
      formSubmitCount:0,
      companyName: '',
      companySlogan: '',
      description:'',
      motives:'',
      videoSources: [],
      clients:[],
      teamMembers: [],
      title:"",
      form: {
        name: '',
        email: '',
        message: ''
      },
      ackMessage: "",
      textIndex: this.texts.length - 1,
      time: new Date(),
      morph: 0,
      cooldown: this.cooldownTime,
    };
  },
  created() {
    this.fetchCompanyDetails();
    this.fetchTeamMembers();
  },
  mounted(){
    this.text1 = this.$refs.text1;
    this.text2 = this.$refs.text2;
    this.animate();
    // var client_container_width = $(window).width();
    // $('.marquee-client-container').css('width', client_container_width);
    const updateWidth = () => {
      const w = $(window).width();
      $('.marquee-client-container, .about-us').css({'width': w,'transition': 'none'});
    };
    
    updateWidth();
    // this.setVideoAttributesForMobile();
    $(window).on('resize', () => {
      updateWidth();
    });
  },
  beforeUnmount(){
    window.cancelAnimationFrame(this.animationId);
    $(window).off('resize');
  },
  methods: {
    
    async fetchCompanyDetails() {
      try {
        const response =  {
          id: 1,
          name: 'Zero Latency Productions',
          slogan: 'Your Vision Our Creation',
          description: 'Your ultimate destination for all\n' +
            'your creative needs! As a leading media production house, we offer a\n' +
            'comprehensive range of services to cater to every aspect of your visual\n' +
            'requirements. Whether you need professional video editing, stunning\n' +
            'product photography, captivating video shoots, mesmerizing travel\n' +
            'videography, unforgettable wedding shoots, innovative retail product\n' +
            'design, 3D product modelling and animation or eye-catching graphic design, we have the expertise and\n' +
            'passion to exceed your expectations.',
          category: 'Production Agency',
          motives: 'Our objective is to consistently provide our clients with high-quality\r\n' +
            'productions. We are committed to quality in all aspects of our work,\r\n' +
            'from pre-production through production and post-production. We\r\n' +
            'seek to create aesthetically attractive, emotionally gripping, and\r\n' +
            'intellectually interesting material that captivates and connects\r\n' +
            'according to the needs of our clients.'
        }
        
        this.description = response.description;
        
        this.motives = response.motives;
        this.companySlogan = response.slogan;
        this.title = response.name;
        const clients = [
          // {
          //   id: 1,
          //   name: 'Curly Tales',
          //   client_since: '20/12/2016',
          //   client_logo: '/images/clients/Curly Tales.png'
          // },
          {
            id: 2,
            name: 'Mahindra',
            client_since: '01/01/2024',
            client_logo: '/images/clients/Mahindra Sustain.png'
          },
          {
            id: 3,
            name: 'Mahindra',
            client_since: '01/01/2024',
            client_logo: '/images/clients/Mahindra Tractors.png'
          },
          {
            id: 4,
            name: 'Contiki spain',
            client_since: '01/01/2024',
            client_logo: '/images/clients/Contiki spain.png'
          },
          {
            id: 5,
            name: 'Ndtv',
            client_since: '01/01/2024',
            client_logo: '/images/clients/ndtv.png'
          },
          {
            id: 6,
            name: 'G Shock',
            client_since: '01/01/2024',
            client_logo: '/images/clients/G Shock.png'
          },
          {
            id: 7,
            name: 'Globalogy',
            client_since: '01/01/2024',
            client_logo: '/images/clients/Globalogy.png'
          },
          {
            id: 8,
            name: 'Groto',
            client_since: '01/01/2024',
            client_logo: '/images/clients/Groto.png'
          },
          {
            id: 9,
            name: 'MCD',
            client_since: '01/01/2024',
            client_logo: '/images/clients/MCD.png'
          },
          {
            id: 10,
            name: 'POI',
            client_since: '01/01/2024',
            client_logo: '/images/clients/POI.png'
          },
          {
            id: 11,
            name: 'queensland Tourism',
            client_since: '01/01/2024',
            client_logo: '/images/clients/queensland Tourism.png'
          },
          {
            id: 12,
            name: 'ride',
            client_since: '01/01/2024',
            client_logo: '/images/clients/ride.png'
          },
          {
            id: 13,
            name: 'Samsung',
            client_since: '01/01/2024',
            client_logo: '/images/clients/Samsung.png'
          },
          {
            id: 14,
            name: 'Seal Ashram',
            client_since: '01/01/2024',
            client_logo: '/images/clients/Seal Ashram.png'
          },
          {
            id: 15,
            name: 'Tripoto',
            client_since: '01/01/2024',
            client_logo: '/images/clients/Tripoto.png'
          },
        ]
        // console.log(clients,response.data);
        this.clients = clients;
        const allCategories = [
          {
            id: 35,
            title: 'Videography',
            category: 'portfolio_cover',
            path: '/videos/portfolio/portfolio-videography.mp4',
            type: 'video',
            video_code: '/videography'
          },
          {
            id: 36,
            title: 'Video Editing',
            category: 'portfolio_cover',
            path: '/videos/portfolio/portfolio-video-editing.mp4',
            type: 'video',
            video_code: '/videoediting'
          },
          {
            id: 37,
            title: 'Photography',
            category: 'portfolio_cover',
            path: '/videos/portfolio/portfolio-photography.mp4',
            type: 'video',
            video_code: '/photography'
          },
          {
            id: 38,
            title: 'Graphic Designing',
            category: 'portfolio_cover',
            path: '/videos/portfolio/portfolio-graphic-designing.mp4',
            type: 'video',
            video_code: '/graphicdesigning'
          },
          // {
          //   id: 39,
          //   title: '3D Modeling',
          //   category: 'portfolio_cover',
          //   path: '/videos/portfolio/portfolio-3d-modeling.mp4',
          //   type: 'video',
          //   video_code: '/3dmodeling'
          // }
        ]
        this.videoSources = allCategories;
      } catch (error) {
        console.error('Error fetching company details:', error);
      }
    },
    async fetchTeamMembers() {
        try {
          const team_members =[
            {
              id: 1,
              name: 'Gunish Vaity',
              role: 'Founder',
              bio: 'Video Editor',
              avatar: 'https://i.postimg.cc/63B8BgfV/gunish-emoji-20240826-192305.png',
              avatar_real: '/images/members/Gunish IMG.jpg'
            },
            {
              id: 2,
              name: 'Tanish Vaity',
              role: 'Co - Founder',
              bio: 'Creative director',
              avatar: 'https://i.postimg.cc/50p6ygsh/tanish-emoji-20240826-192313.png',
              avatar_real: '/images/members/Tanish IMG.jpg'
            },
            {
              id: 3,
              name: 'Deepak Gupta',
              role: 'Co - Founder',
              bio: 'Director of Photography',
              avatar: 'https://i.postimg.cc/Kz4vjsKN/deepak-emoji-20240826-192257.png',
              avatar_real: '/images/members/Deepak IMG.jpg'
            },
            // {
            //   id: 4,
            //   name: 'Shubham Kokane',
            //   role: 'Co - Founder',
            //   bio: 'VFX / 3D Artist',
            //   avatar: '/images/members/shubham_emoji-20240826_192311.png',
            //   avatar_real: '/images/members/shubham_real-20240826_192312.png'
            // }
          ]
          this.teamMembers = team_members;
        } catch (error) {
          console.error('Error fetching team members:', error);
        }
      },
    handleMouseOver(event) {
        const video = event.target;
        if (video && video.paused) {
          video.play().catch(() => {
          });
        }else{
          video.pause()
        }
      },
      handleMouseOut(event) {
        const video = event.target;
        if (video && !video.paused) {
          video.pause();
        }
      },
      
      async submitForm() {
        if (this.validateForm()) {
          try {
            if(this.formSubmitCount >=2){
              this.ackMessage = 'You cannot send any more messages.';
              this.form.email="";
              this.form.name="";
              this.form.message="";
              return;
            }
            // const response = await axios.post(`${process.env.BACKEND_APP_API_BASE_URL}/api/contacts`, this.form);
            // console.log(this.form);
            emailjs.init(process.env.EJS_PUBLIC_KEY)
            let response = await emailjs.send(process.env.EJS_SERVICE_KEY, process.env.EJS_TEMPLET_KEY, {
                  from_name: this.form.name,
                  from_email: this.form.email,
                  message: this.form.message
              })
            if(response.status === 200){
              this.ackMessage = 'Message sent successfully! We will connect with you, soon.';
              this.form.email="";
              this.form.name="";
              this.form.message="";
              this.formSubmitCount++;
            }else{
              this.ackMessage = 'Failed to send message. Please try again.';
              this.form.email="";
              this.form.name="";
              this.form.message="";
            }
        } catch (error) {
          this.ackMessage = 'Error occurred. Please try again later.';
        }
        }
      },
      validateForm() {
        // Simple validation example
        if (!this.form.name || !this.form.email || !this.form.message) {
          alert('All fields are required.');
          return false;
        }
        if (!this.isValidEmail(this.form.email)) {
          alert('Please enter a valid email address.');
          return false;
        }
        return true;
      },
      isValidEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      },
      doMorph() {
      this.morph -= this.cooldown;
      this.cooldown = 0;

      let fraction = this.morph / this.morphTime;

      if (fraction > 1) {
        this.cooldown = this.cooldownTime;
        fraction = 1;
      }

      this.setMorph(fraction);
    },
    setMorph(fraction) {
      this.text2.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
      this.text2.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

      fraction = 1 - fraction;
      this.text1.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
      this.text1.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

      this.text1.textContent = this.texts[this.textIndex % this.texts.length];
      this.text2.textContent = this.texts[(this.textIndex + 1) % this.texts.length];
    },
    doCooldown() {
      this.morph = 0;

      this.text2.style.filter = "";
      this.text2.style.opacity = "100%";

      this.text1.style.filter = "";
      this.text1.style.opacity = "0%";
    },
    animate() {
      this.animationId = window.requestAnimationFrame(this.animate);

      let newTime = new Date();
      let shouldIncrementIndex = this.cooldown > 0;
      let dt = (newTime - this.time) / 1000;
      this.time = newTime;

      this.cooldown -= dt;

      if (this.cooldown <= 0) {
        if (shouldIncrementIndex) {
          this.textIndex++;
        }

        this.doMorph();
      } else {
        this.doCooldown();
      }
    },
    scrollToSection(sectionID) {
      const section = document.getElementById(sectionID);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    
  },
  refs: {
    text1: null,
    text2: null,
  },

};
window.addEventListener('scroll', debounce(reveal, 20)); // Debounced for better performance

function reveal() {
  const reveals = document.querySelectorAll('.reveal');
  const windowHeight = window.innerHeight;
  const revealPoint = 100;

  for (let i = 0; i < reveals.length; i++) {
    const revealTop = reveals[i].getBoundingClientRect().top;

    if (revealTop < windowHeight - revealPoint) {
      reveals[i].classList.add('active');
    } else {
      reveals[i].classList.remove('active');
    }
  }
}

// Debounce utility function
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}



</script>
<!-- <script src="/js/companyTitle.js"></script> -->
<!-- <style scoped src="@/../public/css/home.css"></style> -->


